<div
  class="absolute"
  [class.select-none]="draggable()"
  (click)="onEventClick()"
  (keydown)="onEventClick()"
  [style.height.px]="renderedHeight()"
  [style.top.px]="renderedTop()"
  [style.left.%]="event().position?.left ?? 0"
  [style.width]="blockWidth()"
  [style.transform]="previewTransform()"
  [style.opacity]="dimmed() ? dimmedOpacity : null"
  [style.z-index]="dragging() ? 50 : baseZIndex">
  <div
    #calendarEventRef
    class="group duration-fast relative box-border flex h-full w-full flex-col overflow-hidden transition-[box-shadow,opacity] ease-out"
    [class.cursor-grab]="draggable() && !dragging()"
    [class.cursor-grabbing]="draggable() && dragging()"
    (pointerdown)="onPointerDown($event, 'move')"
    [style.box-shadow]="dragging() ? dragRing : null"
    [style.background]="blockFill()"
    [style.border-top]="railBorder()"
    [style.border-right]="edgeBorder"
    [style.border-bottom]="bottomBorder()"
    [style.border-left]="edgeBorder"
    [style.border-radius]="blockRadius()">
    @let cutoff = cutoffMarker();
    @if (cutoff) {
      <app-calendar-event-cutoff
        [offsetPx]="cutoff.offsetPx"
        [time]="cutoff.time"
        [color]="cutoff.color" />
    }

    <!-- Blocks under 15px have no room for a line of text, so they render as a bare tinted band. -->
    @if (renderedHeight() >= 15) {
      <div
        class="pointer-events-none relative z-2 flex min-w-0 flex-col justify-center gap-px"
        [class]="renderedHeight() >= 22 ? 'px-1.5 py-0.5' : 'px-1.5'">
        <div class="flex min-w-0 items-center gap-1.5">
          @if (recurrenceLabel()) {
            <i
              data-testid="event-recurrence"
              [class]="ICONS.repeat"
              class="shrink-0 text-[11px] opacity-55"></i>
          }
          <span class="text-2xs min-w-0 flex-1 truncate font-semibold">
            @if (showTimesInsteadOfTitle()) {
              <span data-testid="event-times" class="font-mono font-medium">
                {{ timeRangeLabel() }}
              </span>
            } @else {
              {{ event().title }}
            }
          </span>
        </div>

        @if (renderedHeight() >= 32) {
          <span
            data-testid="event-times"
            class="flex min-w-0 items-center gap-1 truncate font-mono text-[10px] whitespace-nowrap"
            [style.color]="metaInk()">
            {{ timeRangeLabel() }}
          </span>
        }
      </div>
    }

    @if (draggable()) {
      <!-- Top edge handle: resize the event start -->
      <div
        class="absolute top-0 right-0 left-0 z-3 h-[6px] cursor-ns-resize"
        (pointerdown)="onPointerDown($event, 'resize-start')"></div>
      <!-- Bottom edge handle: resize the event end -->
      <div
        class="absolute right-0 bottom-0 left-0 z-3 h-[6px] cursor-ns-resize"
        (pointerdown)="onPointerDown($event, 'resize-end')"></div>
    }
  </div>
</div>

<app-tooltip
  class="z-100"
  [target]="calendarEventRef"
  [position]="'top'"
  [title]="tooltipTitle()"
  [content]="tooltipContent()"
  [interactive]="true"
  [disabled]="dragging()" />
